<div class="container">
  <div class="row container--flex">
    <div class="col is-relative">
      <mat-card *ngIf="!hasChanged; else passwordChanged" class="card_container">
        <mat-card-header>
          <mat-card-title>Change Password</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="container">
            <small class="text-bold text-block text-upper text-align-right">*required field</small>

            <ecp-reset-password-form #resetPassword (submit)="handleSubmit()" (passwordFocused)="isFocused = $event">
            </ecp-reset-password-form>

            <ng-container *ngFor="let error of errors">
              <mat-error class="mb-20" style="margin-top: -10px">
                <fa-icon icon="exclamation-triangle"></fa-icon>
                {{ error.errorSummary }}
              </mat-error>
            </ng-container>

            <ecp-password-requirements
              class="password-requirement--mobile"
              [passwordField]="passwordValue"
              [validationList]="validationList"
              *ngIf="passwordValue && isFocused && passwordValue.invalid"
            >
            </ecp-password-requirements>

            <div class="btn-group-vertical mt-20">
              <button
                class="btn btn-primary"
                name="reset-password"
                (click)="handleSubmit()"
                [disabled]="isLoading || resetPassword.form.invalid"
              >
                Change Password
                <fa-icon *ngIf="isLoading" icon="spinner" [spin]="true"></fa-icon>
              </button>
              <button class="btn btn-link" (click)="returnToLogin()">
                Return to Login
              </button>
            </div>
          </div>
        </mat-card-content>
        <mat-card-footer class="no-divider">
          <p class="text-align-left">
            if you need further assistance, please contact our <a routerLink="/contact-us">Customer Support</a> team.
          </p>
        </mat-card-footer>
      </mat-card>
      <ecp-password-requirements
        class="password-requirement--desktop"
        [passwordField]="passwordValue"
        [validationList]="validationList"
        *ngIf="passwordValue && isFocused && passwordValue.invalid"
      >
      </ecp-password-requirements>

      <ng-template #passwordChanged>
        <mat-card>
          <mat-card-header class="no-divider">
            <mat-card-title>Reset Password</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="container">
              <p>Your password was changed successfully!</p>
              <p>
                if you need further assistance, please contact our
                <a routerLink="/contact-us">Customer Support</a> team.
              </p>
            </div>
          </mat-card-content>
          <mat-card-actions>
            <a routerLink="/" class="btn btn-link">Return to login</a>
          </mat-card-actions>
        </mat-card>
      </ng-template>
    </div>
  </div>
</div>
